import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const Header = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      const mobileMenu = document.querySelector('.mobile-menu');
      const hamburgerButton = document.querySelector('.mobile-menu-button');

      if (mobileMenu && hamburgerButton && !mobileMenu.contains(event.target) && !hamburgerButton.contains(event.target)) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  const getStartJourneyText = () => {
    if (location.pathname === '/indian') {
      return 'Accelerate Growth';
    } else if (location.pathname === '/global') {
      return 'Expand in India';
    } else if (location.pathname === '/enterprise') {
      return 'Partner with Startups';
    } else {
      return 'Start your journey';
    }
  };

  const getStartJourneyLink = () => {
    if (location.pathname === '/indian') {
      return 'https://forms.gle/F1AhEsmWPnMmpXGM7';
    } else if (location.pathname === '/global') {
      return 'https://forms.gle/MAgquUKQDY4k9gjH8';
    } else if (location.pathname === '/enterprise') {
      return 'https://forms.gle/hRT1f96s5cWEg16U8';
    } else {
      return 'https://forms.gle/Brpzz6dAtLtcTYc9A';
    }
  };


  return (
    <header className="bg-white/90 shadow-md sticky top-0 z-20 backdrop-blur-sm">
      <div className="container max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo Section */}
        <a href='/' className="mobile-logo"> 
          <img className="w-auto h-12 md:h-16" src="img/logo.png" alt="Logo" /> 
        </a>

        {/* Mobile Navigation Button (Hamburger) */}
        <div className="md:hidden mobile-menu-button">
          <button
            onClick={toggleMobileMenu}
            className="focus:outline-none p-2 -mr-2" // Added padding and negative right margin for better touch area
          >
            <svg
              className="w-6 h-6 text-gray-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </button>
        </div>

        {/* Desktop Navigation Section */}
        <nav className="hidden md:flex space-x-8 items-center bg-gray-200 p-2 rounded-full px-6">
          <a href="/" className="text-gray-800 hover:text-blue-600 transition-colors duration-200">Home</a>
          <a href="/about" className="text-gray-800 hover:text-blue-600 transition-colors duration-200">About us</a>
          <a href="/indian" className="text-gray-800 hover:text-blue-600 transition-colors duration-200">Accelerate</a>
          <a href="/global" className="text-gray-800 hover:text-blue-600 transition-colors duration-200">Scale</a>
          <a href="/enterprise" className="text-gray-800 hover:text-blue-600 transition-colors duration-200">Co-create</a>
          <a href="/launchhub" className="text-gray-800 hover:text-blue-600 transition-colors duration-200">Launch Hub</a>


          <a
            href={getStartJourneyLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-700 hover:bg-blue-800 text-white font-semibold text-sm px-4 py-2 rounded-full shadow-md transition-colors duration-200"
          >
            {getStartJourneyText()}
          </a>
        </nav>

        {/* Mobile Menu */}
        <div
          className={`mobile-menu md:hidden absolute top-full right-0 bg-white shadow-lg mt-2 rounded-lg overflow-hidden transition-all duration-200 ${isMobileMenuOpen ? 'block' : 'hidden'
          }`}
          style={{ right: '1rem', width: '220px', zIndex: 10 }}
        >
          <div className="py-2 flex flex-col">
            <a href="/" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 transition-colors duration-200">Home</a>
            <a href="/about" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 transition-colors duration-200">About us</a>
            <a href="/indian" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 transition-colors duration-200">Accelerate</a>
            <a href="/global" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 transition-colors duration-200">Scale</a>
            <a href="/enterprise" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 transition-colors duration-200">Co-create</a>
          <a href="/launchhub" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 transition-colors duration-200">Launch Hub</a>


            <a
              href={getStartJourneyLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="block mx-4 mt-2 text-center bg-blue-700 hover:bg-blue-800 text-white font-semibold py-2 rounded-md shadow-md transition-colors duration-200"
            >
              {getStartJourneyText()}
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;